export enum ProgressStatusEnum {
  LESSON = 'LESSON',
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REPROVED = 'REPROVED',
}